module.exports = __webpack_public_path__ + "img/circle-border.13250c97.svg";